import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/BlogList.css";
import fetchBlogs from "../api/blogApi";
import useSeoData from "../hooks/useSeoData";
import MetaTags from "./MetaTags";

const BlogList = () => {
  const { seoData } = useSeoData('/blogs');
  const [blogs, setBlogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getBlogs = async () => {
      setLoading(true);
      try {
        const data = await fetchBlogs(page, limit);
        setBlogs(data.blogs);
        setTotal(Number(data.total));
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getBlogs();
  }, [page]);

  const totalPages = Math.ceil(total / limit);

  if (loading)
    return (
      <div className="loading-container">
        <div className="loader"></div>
        <p>Loading blogs...</p>
      </div>
    );
  if (error)
    return <div className="error">Error fetching blogs: {error.message}</div>;

  return (
    <div className="blog-list">
      <MetaTags
        title={seoData.meta_title || "Default Title"} 
        description={seoData.meta_description || "Default Description"} 
        robots={seoData.meta_robots || "Default Robots"} 
        canonical={seoData.canonical_link || "https://sixdindia.com/"} 
        schema={seoData.schema_code?.replaceAll('&quot;', '"') || "{}"}
        googleAnalyticsCode={seoData.google_analytics_code} // Pass the Google Analytics code
      />
      <div className="blog-list-container">
        <section className="caseHero">
          <div>
            <p className="caseTitle font-face-futur-md-bt">Blogs <br /><span className="caseSubTitle font-face-futur-md-bt">Insights & Innovations in Energy</span></p>
            <div className="drawing-bar" />
            <p />
            <p className="casePara font-face-futur-bk ">
              Stay updated with expert insights on oil & gas, offshore development, and sustainable energy solutions. Join us as we explore the industry's biggest challenges and opportunities.
            </p>
          </div>
        </section>
        <div className="list-container" style={{ marginTop: '20px' }}>
          {blogs
            .map((item) => (
              <Link to={`/blog/${item.slug}`} key={item.id}>
                <div className="list-item">
                  <div className="list-item-left">
                    <h2 className="font-face-futur-md-bt">{item.title}</h2>
                    <p className="font-face-futur-LT">{item.description.replace(/<[^>]+>/g, "").slice(0, 200)}...</p>
                  </div>
                  <div className="list-item-right">
                    <img src={`http://admin.sixdindia.com/${item.image}`} style={{ maxHeight: '200px' }} alt={item.title} />
                  </div>
                </div>
              </Link>
            ))}
        </div>
        <div className="pagination">
          <button
            onClick={() => setPage(page - 1)}
            disabled={page === 1}
            className="btnFl"
          >
            Previous
          </button>
          <div className="pagination-info">
            Page {page} of {totalPages}
          </div>
          <button
            onClick={() => setPage(page + 1)}
            disabled={page === totalPages}
            className="btnFl"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogList;
